<template>
  <strong>{{
    (paginate.current_page - 1) * paginate.per_page + 1 + index
  }}</strong>
</template>
<script>
export default {
  name: 'TableNumber2',
  props: ["paginate", "index"],
};
</script>